module.exports = __webpack_public_path__ + "static/scale-model-of-public-art-\"timekeeper\"-in-pasadena-california-7d2d2eee62713bc0f340de739357f944.png";